import axios from 'axios';
import { IAvailableAppointmentModel } from '@/visa-application/models/AvailableAppointmentModel';
import { APPOINTMENT_ENDPOINT } from '@/shared/constants/endpoint';
import { buildConfigWithRecaptchaHeader } from '@/shared/utils/recaptcha';
import { LOCAL_COUNTRY } from '@/constants';
const baseApiUrl = 'services/customerservice/api/tls';
export default class AppointmentService {
  public retrieve(client: string, issuer: string, formGroupId: number): Promise<any> {
    return axios.get(`${APPOINTMENT_ENDPOINT}?client=${client}&issuer=${issuer}&formGroupId=${formGroupId}`);
  }

  public getAppointmentByAppointmentType(
    residenceCountry: string,
    client: string,
    issuer: string,
    formGroupId: number,
    appointmentType: string,
    appointmentStage: string
  ): Promise<any> {
    return axios.get(
      `${APPOINTMENT_ENDPOINT}/${residenceCountry}/${issuer}/table?client=${client}&formGroupId=${formGroupId}` +
        `&appointmentType=${appointmentType}&appointmentStage=${appointmentStage}`
    );
  }

  public book(
    client: string,
    issuer: string,
    formGroupId: number,
    timeslot: string,
    appointmentType: string,
    accountType: string,
    lang: string,
    token: string,
    skusByForm: any[]
  ): Promise<any> {
    return axios
      .post(
        `${APPOINTMENT_ENDPOINT}/book?client=${client}&issuer=${issuer}&formGroupId=${formGroupId}&timeslot=${timeslot}&appointmentType=${appointmentType}&accountType=${accountType}&lang=${lang}`,
        skusByForm,
        buildConfigWithRecaptchaHeader(token)
      )
      .then(res => res.data);
  }

  // amend
  public amend(
    issuer: string,
    fg_id: number,
    action: string,
    timeslot: string,
    appointment_type: string,
    lang: string,
    token: string,
    skusByForm: any[]
  ): Promise<any> {
    return axios
      .put(
        `${APPOINTMENT_ENDPOINT}/${LOCAL_COUNTRY}/group_appointment/book?` +
          `issuer=${issuer}` +
          `&fg_id=${fg_id}` +
          `&action=${action}` +
          `&timeslot=${timeslot}` +
          `&appointment_type=${appointment_type}` +
          `&lang=${lang}`,
        skusByForm,
        buildConfigWithRecaptchaHeader(token)
      )
      .then(res => res.data);
  }

  public getNextAppointmentsAvailable(residenceCountryCode: string, client: string): Promise<IAvailableAppointmentModel[]> {
    return axios.get<IAvailableAppointmentModel[]>(`${APPOINTMENT_ENDPOINT}/${residenceCountryCode}/table/${client}`).then(res => res.data);
  }

  public cancel(client: string, issuer: string, formGroupId: number, action: string, cancelComment: string, lang: string): Promise<any> {
    return axios
      .post(
        `${APPOINTMENT_ENDPOINT}/cancel?client=${client}&issuer=${issuer}&formGroupId=${formGroupId}&action=${action}&cancelComment=${cancelComment}&lang=${lang}`
      )
      .then(res => res.data);
  }

  /**
   * Get date of the appointment for a list of forms (if an appointment was booked)
   * @param client Application client
   * @param formIds A list of form IDs you wish to get appointment dates for
   */
  public getFormsAppointmentDates(client: string, issuer: string, fgId: number): Promise<Map<number, string>> {
    return axios.get(`${APPOINTMENT_ENDPOINT}/forms/${client}/${issuer}/${fgId}`).then(result => {
      const map = new Map<number, string>();
      Object.keys(result.data).forEach(value => map.set(+value, result.data[value]));
      return map;
    });
  }

  // get formGroup appointment stage status n_a,panding,book...
  public canBook(client: string, issuer: string, formGroupId: number): Promise<any> {
    return axios
      .get(`${APPOINTMENT_ENDPOINT}/bookstatus/${client}/${issuer}/${formGroupId}`)
      .then(res => res.data)
      .catch(err => {
        return {
          code: 400,
          data: err
        };
      });
  }

  // get formGroup appointment type
  public getGroupAppointmentType(client: string, issuer: string, formGroupId: number): Promise<any> {
    return axios
      .get(`${APPOINTMENT_ENDPOINT}/appointment_type/${client}/${issuer}/${formGroupId}`)
      .then(res => res.data)
      .catch(err => err);
  }
  // 波兰预约提交状态
  // Polish reservation submission status
  public getChangeAppointmentStatus(
    client: string,
    issuer: string,
    fgId: number,
    timeslot: string,
    status: string,
    lang: string
  ): Promise<any> {
    return axios
      .post(
        `${baseApiUrl}/formgroup/changeAppointmentStatus/${client}/${issuer}/${fgId}?timeslot=${timeslot}&status=${status}&lang=${lang}`
      )
      .then(res => res.data)
      .catch(err => err);
  }
  // 获取波兰预约时间
  public getAppointmentDate(client: string, issuer: string, fgId: number): Promise<any> {
    return axios
      .get(`${baseApiUrl}/formgroup/getAppointmentDate/${client}/${issuer}/${fgId}`)
      .then(res => res.data)
      .catch(err => err);
  }
}
